import { useSelector } from 'react-redux';
import { GruserReduxSlice } from '../types/store';
import { getModuleDataByModuleName } from '../redux/selectors/modules';
import useGruser from './useGruser';
import { ModuleName } from '../types/modules';

/** Returns the first Gruser module found with the given module name */
export default function useModuleDataByName(moduleName: ModuleName) {
  const { gruser } = useGruser();
  return useSelector(state =>
    getModuleDataByModuleName(state as GruserReduxSlice, gruser, moduleName)
  );
}
